module.exports = __webpack_public_path__ + "img/VP-UL_Overview-Front_1.0259cb7b.jpg";